import axios from 'axios'

function emptyPodft () {
  return { success: true, message: '', setDocument: false }
}

export function ensureVehicleVerifyState (vehicle) {
  if (!vehicle || typeof vehicle !== 'object') {
    return vehicle
  }
  if (!Object.prototype.hasOwnProperty.call(vehicle, 'beingVerify')) {
    vehicle.beingVerify = false
  }
  if (!vehicle.podft || typeof vehicle.podft !== 'object') {
    vehicle.podft = emptyPodft()
  }
  return vehicle
}

export function useBpmVehicleVerify ({ notify }) {
  function verifyVehicle (vehicle) {
    const target = ensureVehicleVerifyState(vehicle)
    if (!target || target.beingVerify) {
      return Promise.resolve()
    }

    target.beingVerify = true
    target.podft = emptyPodft()

    return axios
      .post('/api/v2/vehicle/bpm/verify', target)
      .then(res => {
        const data = res.data || {}
        target.podft = {
          success: data.success !== false,
          message: data.message || '',
          code: data.code || 0,
          setDocument: !!data.setDocument,
        }
        if (!target.podft.success) {
          notify.error({ message: 'Авто: ' + target.vehicle.number + ', VIN: ' + target.vehicle.vin + '. ' + target.podft.message || 'Проверка авто не пройдена' })
        }
      })
      .catch(err => {
        target.podft = {
          success: false,
          message: 'Ошибка при проверке авто. Попробуйте снова.',
          code: 0,
          setDocument: false,
        }
        notify.error(err)
      })
      .finally(() => {
        target.beingVerify = false
      })
  }

  return {
    verifyVehicle,
    ensureVehicleVerifyState,
  }
}
